import { ThicknessInspectionReportType } from '../reports/thickness-reports/thickness-report';

export class DrawingInspectionPointData {
  inspectionPointId: string;
  thicknessLocationId: string;
  inspectionPointTypeId: string;
  lastInspectionDate: Date;
  lastThicknessReportType: ThicknessInspectionReportType;
  dueDate: Date;

  public json(): any {
    return this;
  }

  public loadFromJson(data: any): void {
    this.inspectionPointId = data.inspectionPointId;
    this.thicknessLocationId = data.thicknessLocationId;
    this.inspectionPointTypeId = data.inspectionPointTypeId;
    this.lastInspectionDate = data.lastInspectionDate;
    this.lastThicknessReportType = data.lastThicknessReportType;
    this.dueDate = data.dueDate;
  }
}
